import { keptReasonLabel, seriesDateLabel } from "./courtSeriesModel";
import { intervalHeading } from "../../turnos/agenda/turnoFijoModel";
import "./CourtSeries.css";

/*
 * Dates a series cancel left as they were because they already have a charge
 * or a check-in. The organizer has to know which ones still stand.
 * `intervalWeeks` (when the cancel answer carries the series) says how often it repeats.
 * `reasonLabels` lets a vertical word the reasons its own way (Beauty: "con ingreso").
 */
export default function CourtSeriesKeptReport({ kept, reasonLabels, intervalWeeks }) {
	if (!Array.isArray(kept) || kept.length === 0) return null;
	return (
		<div className="csr-kept" role="status">
			<p className="csr-kept__title">
				{kept.length === 1
					? "Se mantuvo 1 fecha:"
					: `Se mantuvieron ${kept.length} fechas:`}
			</p>
			{intervalWeeks ? (
				<p className="csr-kept__interval">{intervalHeading(intervalWeeks)}</p>
			) : null}
			<ul className="csr-kept__list" aria-label="Fechas que se mantuvieron">
				{kept.map((item) => (
					<li key={item.reservationId || item.date}>
						<strong>{seriesDateLabel(item.date)}</strong>
						<span>{reasonLabels?.[item.reason] || keptReasonLabel(item.reason)}</span>
					</li>
				))}
			</ul>
		</div>
	);
}
